import { useQuery } from '@tanstack/react-query'
import { useActions } from '../../store'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useAuth, useTenant } from '../'

const { env } = window

const useAccessRequests = () => {
  const { securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()
  const { progressStart, progressEnd } = useActions()
  const { tenant } = useTenant()

  const getAccessRequests = async (tenantId) => {
    const url = encodeURI(`${env.apiUrl}/tenants/${tenantId}/accessRequests`)
    const response = await securedFetch(url)
    await handleResponse(response)
    const data = await response.json()
    const options = data
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((item) => {
        return {
          ...item,
          value: item.id,
          label: item.name,
          disabled: Boolean(item.permission)
        }
      })
    const selected = options.filter((item) => item.disabled)
    return { options, selected }
  }

  const query = useQuery({
    queryKey: ['accessRequests', tenant?.id],
    queryFn: () => getAccessRequests(tenant?.id),
    enabled: !!tenant
  })

  if (query.isLoading) {
    progressStart()
  } else if (query.isSuccess) {
    progressEnd()
  } else if (query.isError) {
    handleError(query.error, 'Error getting access requests')
    progressEnd()
  }

  return { ...query.data }
}

export { useAccessRequests }
